import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect, Link } from 'react-router-dom';
import Timeline, { TimelineMarkers, CustomMarker, TodayMarker, TimelineHeaders, DateHeader, SidebarHeader } from 'react-calendar-timeline';
import 'react-calendar-timeline/lib/Timeline.css';
import moment from 'moment';
import * as actions from '../../store/actions/index';
import { GOOGLE_API_KEY, SCHEDULE_ID, CLOSED_ID, EVENTS_ID } from './gConfig.js';
/* global gapi */

import Aux from '../../hoc/Auxiliary';
import CalendarPopUp from '../../components/UI/CalendarPopUp/CalendarPopUp';
import AddResourceEvent from './AddResourceEvent/AddResourceEvent';
import Button from '../../components/UI/Button/Button';

import classes from './ResourceCalendar.module.css';

class ResourceCalendar extends Component {
    state = {
        mouseLocation: { x: 0, y: 0 },
        showEvent: false,
        updateEvent: false,
        popUp: {
            title: '',
            time: '',
            location: { x: 0, y: 0 },
            idx: 0,
            key: '',
            resources: '',
            resourceId: '',
            group: false,
            description: '',
            requiredClass: '',
            image: ''
        },
        addEvent: false,
        newEventData: {
            eventStart: null,
            eventEnd: null,
            resourceId: -1,
        },
        height: '30px',
        resources: [ { id: 0, title: 'Lab Closed' } ],
        reservations: [],
        gCalEvents: [],
        allEvents: [],
        gCalEventsSet: false,
    };

    async componentDidMount () {
        this.props.getLabHours();
        await this.props.initResources();
        this.setResources();
        const groupKey = {};
        this.state.resources.forEach( ( item, i ) => {
            groupKey[ item.key ] = i;
        } );
        await this.props.initReservations();
        const gCalEvents = await this.getSchedule();
        this.initGCal( gCalEvents );
        this.setReservations( groupKey );
    }

    initGCal = gCalEvents => {
        if( !this.state.gCalEventsSet ) {
            this.setState( { gCalEvents: gCalEvents, gCalEventsSet: true } );
        }
    };

    componentDidUpdate () {
        if( this.state.resources.length === 1 && this.props.resources.length ) {
            this.setResources();
            const groupKey = {};
            this.state.resources.forEach( ( item, i ) => {
                groupKey[ item.key ] = i;
            } );
            this.setReservations( groupKey );
        }
        if( this.state.reservations.length !== this.props.reservations.length ) {
            const groupKey = {};
            this.state.resources.forEach( ( item, i ) => {
                groupKey[ item.key ] = i;
            } );
            this.setReservations( groupKey );
        }
    }

    //Google Calendar
    loadGoogle = ( id, whichCall, eventList ) => {
        const that = this;
        gapi.client
            .init( {
                apiKey: GOOGLE_API_KEY,
            } )
            .then( function () {
                return gapi.client.request( {
                    path: `https://www.googleapis.com/calendar/v3/calendars/${id}/events?timeMin=${moment().toISOString()}`,
                } );
            } )
            .then( response => {
                const events = [];
                response.result.items.forEach( ( item, i ) => {
                    let event = {};
                    if( item.status !== 'cancelled' ) {
                        if( item.start.dateTime ) {
                            event = {
                                id: whichCall + i,
                                key: item.id,
                                title: item.summary,
                                start_time: moment( item.start.dateTime ),
                                end_time: moment( item.end.dateTime ),
                                group: 0,
                                madeBy: whichCall
                            };
                        } else {
                            event = {
                                id: whichCall + i,
                                key: item.id,
                                title: item.summary,
                                start_time: moment( item.start.date ),
                                end_time: moment( item.start.date ).add( 24, 'hours' ),
                                group: 0,
                                madeBy: whichCall
                            };
                        }
                    }

                    eventList.push( event );
                } );
            } );
    };

    getSchedule = () => {
        const gCalEventsList = [];
        gapi.load( 'client', { callback: () => this.loadGoogle( EVENTS_ID, 'events', gCalEventsList ) } );
        gapi.load( 'client', { callback: () => this.loadGoogle( SCHEDULE_ID, 'schedule', gCalEventsList ) } );
        gapi.load( 'client', { callback: () => this.loadGoogle( CLOSED_ID, 'closed', gCalEventsList ) } );
        return gCalEventsList;
    };

    setReservations = groupKey => {
        if( this.state.gCalEventsSet ) {
            const reservationList = [];
            this.props.reservations.forEach( ( item, i ) => {
                reservationList.push( {
                    id: i + 1,
                    key: item.key,
                    madeBy: item.user,
                    group: groupKey[ item.resource ],
                    title: item.title,
                    start_time: moment( item.startTime ),
                    end_time: moment( item.endTime ),
                } );
            } );
            this.setState( { reservations: reservationList } );
        }
    };

    setResources = () => {
        const resourceList = [ { id: 0, title: 'Lab Closed', key: 'closed' } ];
        this.props.resources.forEach( ( item, i ) => {
            resourceList.push( {
                id: i + 1,
                title: item.name,
                description: item.description,
                requiredClass: item.requiredClass,
                image: item.image,
                key: item.key,
            } );
        } );
        this.setState( { resources: resourceList } );
    };

    closePopUp = () => {
        this.setState( { showEvent: false } );
    };

    addEventButton = event => {
        if( this.props.user ) {
            event.preventDefault();
            const info = { ...this.state.newEventData };
            info.eventStart = moment().toDate();
            info.eventEnd = moment().add( 1, 'hour' ).toDate();
            this.setState( { addEvent: true, newEventData: info } );
        } else {
            this.props.setMessage( 'Please Sign In to Make a Reservation', 'error' );
        }
    };

    removeEvent = () => {
        console.log( 'delete' );
        console.log( this.state.popUp.key, this.state.popUp.idx );
        this.props.onEventRemoved( this.state.popUp.key );
        this.setState( { showEvent: false } );
    };

    removeAddEvent = () => {
        const empty = { ...this.state.newEventData };
        empty.eventStart = null;
        empty.eventEnd = null;
        empty.resourceId = -1;
        this.setState( { addEvent: false, newEventData: empty } );
    };

    _OnMouseMove ( e ) {
        this.setState( { mouseLocation: { x: e.pageX, y: e.pageY } } );
    }

    itemRenderer = ( { item, itemContext, getItemProps } ) => {
        let className = 'rct-item-content';
        if( item.group === 0 ) {
            className = [ 'rct-item-content', classes.LabClosed ].join( ' ' );
        }
        return (
            <div {...getItemProps( item.itemProps )} className={className}>
                {itemContext.title}
            </div>
        );
    };

    itemClickHandler = ( itemId, e ) => {
        let itemInfo;
        if( typeof itemId === 'number' ) {
            itemInfo = this.state.reservations[ itemId - 1 ];
        } else {
            itemInfo = this.state.gCalEvents.filter( item => item.id === itemId )[ 0 ];
        }
        const newLocation = {
            x: this.state.mouseLocation.x - 100,
            y: this.state.mouseLocation.y - 100,
        };
        const startTime = moment( itemInfo.start_time );
        const endTime = moment( itemInfo.end_time );
        const timeDisplay = `${startTime.format( 'dddd, MMMM Do YYYY, h:mm a' )} - ${endTime.format( 'h:mm a' )}`;
        this.setState( {
            showEvent: true,
            popUp: {
                title: itemInfo.title,
                time: timeDisplay,
                location: newLocation,
                madeBy: itemInfo.madeBy,
                idx: itemId - 1,
                key: itemInfo.key,
                resource: this.state.resources[ itemInfo.group ].title,
                resourceId: itemInfo.group,
                group: false,
            },
        } );
    };

    canvasClickHandler = ( groupId, time ) => {
        if( this.props.user ) {
            const info = { ...this.state.newEventData };
            info.eventStart = moment( time ).toDate();
            info.eventEnd = moment( time ).add( 1, 'hour' ).toDate();
            info.resourceId = groupId;
            this.setState( { addEvent: true, newEventData: info } );
        } else {
            this.props.setMessage( 'Please Sign In to Make a Reservation', 'error' );
        }
    };

    eventAddedHandler = event => {
        const reservationList = [ ...this.state.reservations ];
        const groupKey = {};
        this.state.resources.forEach( ( item, i ) => {
            groupKey[ item.key ] = i;
        } );
        reservationList.push( {
            id: reservationList.length + 1,
            key: 'newItem',
            madeBy: event.user,
            group: groupKey[ event.resource ],
            title: event.title,
            start_time: moment( event.startTime ),
            end_time: moment( event.endTime ),
        } );
        this.setState( { reservations: reservationList } );
        this.props.onEventAdded( event );
    };

    resourceDetailHandler = ( resource ) => {
        const newLocation = {
            x: this.state.mouseLocation.x,
            y: this.state.mouseLocation.y - 100,
        };
        this.setState( {
            showEvent: true,
            popUp: {
                title: resource.title,
                description: resource.description,
                requiredClass: resource.requiredClass,
                image: resource.image,
                location: newLocation,
                group: true
            },
        } );
    }

    groupRenderer = ( { group } ) => {
        return <div onClick={() => this.resourceDetailHandler( group )}>{group.title}</div>
    }

    render () {
        const reservationList = [ ...this.state.reservations ].concat( this.state.gCalEvents );
        let addEvent = null;
        if( this.state.addEvent ) {
            addEvent = (
                <AddResourceEvent
                    close={this.removeAddEvent}
                    start={this.state.newEventData.eventStart}
                    end={this.state.newEventData.eventEnd}
                    resourceId={this.state.newEventData.resourceId}
                    allEvents={reservationList}
                    resources={this.state.resources}
                    permissions={this.props.user.permissions}
                    userName={this.props.user.name}
                    currentId={this.props.currentId}
                    onEventAdded={this.eventAddedHandler}
                    openTime={this.props.openTime}
                    closeTime={this.props.closeTime}
                />
            );
        }
        //const testDate = new Date( 2020, 8, 7 );
        return (
            <div onMouseMove={this._OnMouseMove.bind( this )}>
                {addEvent}
                <CalendarPopUp
                    popUpInformation={this.state.popUp}
                    showEvent={this.state.showEvent}
                    close={this.closePopUp}
                    removeEvent={this.removeEvent}
                    user={this.props.user}
                    currentId={this.props.currentId}
                />
                <Timeline
                    groups={this.state.resources}
                    items={reservationList}
                    defaultTimeStart={moment().add( -12, 'hour' )}
                    //defaultTimeStart={moment( testDate ).add( -12, 'hour' )}
                    defaultTimeEnd={moment().add( 24, 'hour' )}
                    canMove={false}
                    canResize={false}
                    itemRenderer={this.itemRenderer}
                    onItemClick={this.itemClickHandler}
                    onCanvasDoubleClick={this.canvasClickHandler}
                    groupRenderer={this.groupRenderer} >
                    <TimelineHeaders>
                        <SidebarHeader>
                            {( { getRootProps } ) => {
                                return (
                                    <div {...getRootProps} className={classes.LeftHeader}>
                                        <Button clicked={this.addEventButton}>Reserve Machine</Button>
                                    </div>
                                );
                            }}
                        </SidebarHeader>
                        <DateHeader unit="day" labelFormat="dddd, MMMM D, YYYY" />
                        <DateHeader
                            unit="hour"
                            labelFormat="ha"
                            intervalRenderer={( { getIntervalProps, intervalContext } ) => {
                                let time = intervalContext.intervalText;
                                if( time[ time.length - 2 ] === 'a' ) {
                                    if( time.substring( 0, time.length - 2 ) < this.props.openTime || time === '12am' ) {
                                        time = null;
                                    }
                                } else {
                                    if( time.substring( 0, time.length - 2 ) > this.props.closeTime && time !== '12pm' ) {
                                        time = null;
                                    }
                                }
                                return ( <div className={'rct-dateHeader'} {...getIntervalProps()} onClick={() => { }}>
                                    {time}
                                </div> );
                            }}
                        />
                        <DateHeader
                            unit="day"
                            labelFormat="dd"
                            //style={{ height: 50 }}
                            intervalRenderer={( { getIntervalProps, intervalContext } ) => {
                                let text = null;
                                let id = 'Open';
                                if( intervalContext.intervalText === 'Sa' || intervalContext.intervalText === 'Su' ) {
                                    text = 'Closed On Weekends';
                                    id = 'Closed';
                                }
                                return (
                                    <div className={classes[ id ]} {...getIntervalProps()}>
                                        {text}
                                    </div>
                                );
                            }}
                        />
                    </TimelineHeaders>
                </Timeline>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        user: state.auth.currentUser,
        currentId: state.auth.currentId,
        resources: state.resourceCal.resources,
        reservations: state.resourceCal.reservations,
        gCalEvents: state.resourceCal.gCalEvents,
        openTime: state.resourceCal.openTime,
        closeTime: state.resourceCal.closeTime
    };
};

const mapDispatchToProps = dispatch => {
    return {
        initResources: () => dispatch( actions.getResources() ),
        initReservations: () => dispatch( actions.getReservations() ),
        setMessage: ( message, style ) => dispatch( actions.setMessages( message, style ) ),
        onEventAdded: event => dispatch( actions.addResourceEvent( event ) ),
        onEventRemoved: eventId => dispatch( actions.removeResourceEvent( eventId ) ),
        getLabHours: () => dispatch( actions.getLabHours() )
    };
};

export default connect( mapStateToProps, mapDispatchToProps )( ResourceCalendar );
